import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08167dbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-10" }
const _hoisted_5 = {
  key: 0,
  class: "font-weight-bold"
}
const _hoisted_6 = {
  key: 1,
  class: "font-weight-bold customer"
}
const _hoisted_7 = { class: "col-md-2" }
const _hoisted_8 = { style: {"float":"right"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Date ", -1))
const _hoisted_13 = { class: "ml-1" }
const _hoisted_14 = { class: "ml-1" }
const _hoisted_15 = {
  key: 0,
  style: {"max-width":"100%"}
}
const _hoisted_16 = { class: "sender" }
const _hoisted_17 = { class: "message-text" }
const _hoisted_18 = { class: "message-time-left" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-mobile-alt" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { "data-v-219c07a4": "" }, null, -1))
const _hoisted_21 = { class: "message-time-left" }
const _hoisted_22 = {
  key: 1,
  style: {"max-width":"100%","background-color":"#dcf8c6","color":"#9a9a9a"}
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 0,
  class: "tenantresponse"
}
const _hoisted_25 = {
  key: 1,
  class: "tenantresponse"
}
const _hoisted_26 = {
  key: 2,
  class: "tenantresponse"
}
const _hoisted_27 = {
  key: 2,
  style: {"color":"white !important"}
}
const _hoisted_28 = { class: "second-div" }
const _hoisted_29 = {
  key: 0,
  class: "mb-1",
  style: {"white-space":"normal"}
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Title note ")
], -1))
const _hoisted_31 = { class: "ml-1" }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  key: 0,
  class: "mb-1",
  style: {"white-space":"normal"}
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-4" }, null, -1))
const _hoisted_35 = { class: "ml-1" }
const _hoisted_36 = { class: "ml-1" }
const _hoisted_37 = { class: "ml-1" }
const _hoisted_38 = { class: "ml-1" }
const _hoisted_39 = {
  key: 2,
  class: "mb-1",
  style: {"white-space":"normal"}
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Appointment time ")
], -1))
const _hoisted_41 = { class: "ml-1" }
const _hoisted_42 = {
  key: 3,
  class: "piname"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "PI ")
], -1))
const _hoisted_44 = {
  key: 4,
  class: "mb-1",
  style: {"white-space":"normal"}
}
const _hoisted_45 = {
  key: 0,
  class: "piname"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-3" }, null, -1))
const _hoisted_47 = { class: "ml-1" }
const _hoisted_48 = { key: 5 }
const _hoisted_49 = {
  key: 0,
  class: "piname"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-3" }, null, -1))
const _hoisted_51 = { class: "ml-1" }
const _hoisted_52 = {
  key: 6,
  class: "customer"
}
const _hoisted_53 = { key: 7 }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Booked By")
], -1))
const _hoisted_55 = { class: "ml-1" }
const _hoisted_56 = { class: "ml-1" }
const _hoisted_57 = { class: "ml-1" }
const _hoisted_58 = { key: 8 }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "TT ", -1))
const _hoisted_61 = {
  key: 1,
  class: "ml-1"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "TT ", -1))
const _hoisted_63 = {
  key: 2,
  class: "ml-1"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "TT ", -1))
const _hoisted_65 = {
  key: 9,
  class: "mb-1",
  style: {"white-space":"normal"}
}
const _hoisted_66 = { key: 0 }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Key pickup/Access ", -1))
const _hoisted_68 = {
  key: 1,
  class: "ml-1"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Branch ", -1))
const _hoisted_70 = {
  key: 2,
  class: "ml-1"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Phone ", -1))
const _hoisted_72 = {
  key: 10,
  class: "mb-1",
  style: {"white-space":"normal"}
}
const _hoisted_73 = { key: 0 }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Return/Key Release ", -1))
const _hoisted_75 = {
  key: 1,
  class: "ml-1"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Branch ", -1))
const _hoisted_77 = {
  key: 11,
  class: "mb-1"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"white-space":"normal","color":"red"} }, [
  /*#__PURE__*/_createElementVNode("b", null, "Primary Issues ")
], -1))
const _hoisted_79 = {
  key: 12,
  class: "mb-1"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"white-space":"normal","color":"#bd8319"} }, [
  /*#__PURE__*/_createElementVNode("b", null, "Secondary Issues ")
], -1))
const _hoisted_81 = { class: "first-div" }
const _hoisted_82 = ["title"]
const _hoisted_83 = ["title"]
const _hoisted_84 = {
  key: 2,
  class: "fa fa-check-circle icon-botton-right",
  style: {"color":"yellowgreen"},
  title: "Job fully confirmed"
}
const _hoisted_85 = ["title"]

import {
  computed,
  inject,
  onMounted,
  ref,
} from "vue";
import { useStore } from "vuex";
import {
  Dictionary,
  Inspector,
  SelectOption,
  Booking,
  Email,
  PresetError,
} from "@/models";
import { getAppointmentcolour } from "@/utilities";
import moment from "moment-timezone";

export default /*#__PURE__*/_defineComponent({
  __name: 'UnreadSmsEmailLogstResultTemplate',
  props: {
    highlight: {},
    picolour: { type: Boolean },
    rightclick: { type: Boolean },
    showdate: { type: Boolean },
    templateModel: {}
  },
  emits: ["removesmsbookingfromlocal"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const actProperty: any = inject("actProperty");
const store = useStore();

const inspectorlist = computed(
  (): Inspector[] => store.getters["diary/inspectorlist"]
);
const dictionary = computed(
  (): Dictionary => store.getters["dictionary/current"]
);
const selectedbooking = computed(
  () => store.getters["diary/booking"] as Booking
);
const emit = __emit;

const booking = computed((): Booking => {
  return props.templateModel?.appointmentData;
});
const appointmentstyle = computed(() => {
  if (!props.picolour) return "";
  let style = "";
  if (booking.value.id === props.highlight) {
    style = `background-image: conic-gradient(from var(--border-angle), ${appointmentcolour.value}, ${appointmentcolour.value} 50%, ${appointmentcolour.value}), conic-gradient(from var(--border-angle), transparent 20%, #253746, #eadb40);`;
  } else {
    style = `background: ${appointmentcolour.value};`;
  }
  return style;
});

const appointmentcolour = computed(() => {
  return getAppointmentcolour(booking.value, inspectorlist.value);
});

const title = computed(() => {
  return actProperty.getBookingTitle(booking.value, dictionary.value);
});
const getButtonLabel = (val: string) => {
  let label = val;
  if (val === "yes") label = "Yes";
  else if (val === "no") label = "No";
  else if (val === "callback") label = "Call Me";
  else if (val === "option1") label = "Option 1";
  else if (val === "option2") label = "Option 2";
  else if (val === "option3") label = "Option 3";
  else if (val === "option4") label = "Option 4";
  return label;
};

const unreadsmslogs = computed(() => {
  return booking.value.smslogs.logs.filter((l) => l.unread);
});

const removeBookingFromList = (booking: Booking) => {
  if (booking.smslogs.logs.length > 0) {
    emit("removesmsbookingfromlocal", booking, "sms");
  } else {
    emit("removesmsbookingfromlocal", booking, "email");
  }
};

const subbookingdatetimeflag = computed(() => {
  let prepJob = booking.value.subbookings.filter(
    (f: any) => f.subtype === "Prep" || f.subtype === "Key"
  );
  if (prepJob.length > 0) {
    return true;
  } else {
    return false;
  }
});

const primaryErrors = computed(() => {
  return booking.value.preseterrors.filter(
    (f: PresetError) => f.category === "primary"
  );
});
const secondaryErrors = computed(() => {
  return booking.value.preseterrors.filter(
    (f: PresetError) => f.category === "secondary"
  );
});

const prepandKeyJobData = computed(() => {
  let prepandKeyJob = booking.value.subbookings.filter(
    (f: any) => f.subtype === "Prep" || f.subtype === "Key"
  );
  return prepandKeyJob;
});

const getPresetErrorMessage = (error: PresetError) => {
  const errors = [
    {
      message: "No PDF Upload Doc for CO off upload",
      presetnumber: 1,
      flag: false,
    },
    {
      message: "Missing upload ref for CO off upload",
      presetnumber: 2,
      flag: false,
    },
    {
      message: "Appointment time falls outside of booking time",
      presetnumber: 3,
      flag: false,
    },
    {
      message:
        "Appointment time is not the same as booking start time when access is via tenant",
      presetnumber: 4,
      flag: false,
    },
    {
      message: "Booking start time falls outside of agency opening hours",
      presetnumber: 7,
      flag: false,
    },
    {
      message: "Access via tenant for CO/SOC unconfirmed",
      presetnumber: 5,
      flag: false,
    },
    {
      message: "Access unconfirmed (excluding clients that have opted out)",
      presetnumber: 6,
      flag: false,
    },
    {
      message: "Provisional booking (all job types)",
      presetnumber: 8,
      flag: false,
    },
  ];
  const index = errors.findIndex((e) => e.presetnumber === error.presetnumber);
  if (index >= 0) return errors[index].message;
  else return error.message;
};
const masterReportType = computed(() => {
  return actProperty.formatReportType(
    booking.value.leadbooking?.jobtype,
    dictionary
  );
});
const _appointmenttime = computed(() => {
  let apptime = moment(booking.value.appointmenttime).utc().format("h:mm a");
  if (apptime === "12:00 am") apptime = "No Tenant but Fixed Time";
  if (apptime === "12:15 am") apptime = "Flexi all day";
  if (apptime === "12:20 am") apptime = "Flexi AM";
  if (apptime === "12:25 am") apptime = "Flexi PM";
  return apptime;
});
const skulltitle = computed(() => {
  let title = "";
  if (booking.value.checkoutWithoutPreviousReport) {
    title = "Previous report not present";
  } else if (booking.value.checkoutWithoutDataentry) {
    if (!booking.value.dataentryreport) title = "Dataentry report is missing";
    else if (booking.value.dataentryreport.dataentrystatus != "Upload Complete")
      title = "Dataentry report is not completed by dataentry team";
  }
  return title;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["booking", {
      'white-border': booking.value.appointmenttimeoutsidebooking,
      selectedbooking: booking.value.id === selectedbooking.value.id,
      allday: booking.value.isAllDay,
    }]),
    id: 'appointment-box-' + booking.value.id,
    style: _normalizeStyle(appointmentstyle.value)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["card custom-box-shadow text-bg-light mb-6", { 'text-bg-secondary': booking.value.id === selectedbooking.value.id }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "jobtype",
              style: _normalizeStyle({
                color:
                  booking.value.id === selectedbooking.value.id
                    ? 'white !important'
                    : 'black !important',
              })
            }, [
              (_openBlock(), _createElementBlock("span", {
                class: "font-weight-bold",
                key: booking.value.updatedAt
              }, _toDisplayString(title.value), 1)),
              (
                  booking.value.addressPreviewLine1 || booking.value.addressPreviewLine2
                )
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, " - " + _toDisplayString(booking.value.address.displayaddress), 1))
                : _createCommentVNode("", true),
              (booking.value.customer && (booking.value.customer.companyName || booking.value.keypickupbranchname || booking.value.customer.branchName))
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, " - " + _toDisplayString(booking.value.customer.companyName) + " - " + _toDisplayString(booking.value.keypickupbranchname ? booking.value.keypickupbranchname : booking.value.customer.branchName), 1))
                : _createCommentVNode("", true)
            ], 4)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createElementVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (removeBookingFromList(booking.value)), ["stop"])),
                style: _normalizeStyle({
                  color:
                    booking.value.id === selectedbooking.value.id
                      ? 'white !important'
                      : 'black !important',
                })
              }, _hoisted_10, 4)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", {
          class: _normalizeClass(["mb-1", { 'text-white': booking.value.id === selectedbooking.value.id }]),
          style: {"white-space":"normal"}
        }, [
          _createElementVNode("span", null, [
            _hoisted_12,
            _createTextVNode(_toDisplayString(booking.value.bookingdate), 1)
          ]),
          _createElementVNode("span", _hoisted_13, _toDisplayString(booking.value.starttime), 1),
          _createElementVNode("span", _hoisted_14, _toDisplayString(booking.value.endtime), 1)
        ], 2),
        (booking.value && booking.value.smslogs)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unreadsmslogs.value, (log, $index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-md-12 message-main-sender mb-1",
                  key: $index,
                  style: {"max-width":"100%","background-color":"#dcf8c6"}
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, _toDisplayString(log.message), 1),
                    _createElementVNode("span", _hoisted_18, [
                      _hoisted_19,
                      _createTextVNode(" " + _toDisplayString(log.mobile), 1),
                      _hoisted_20
                    ]),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(actProperty).formatUtcDatetimeForDisplay(log.logdate)), 1)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (booking.value && booking.value.emaillogs.tenantemaillogs)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(booking.value.emaillogs.tenantemaillogs, (emaillog, $index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-md-12 message-main-sender",
                  key: $index
                }, [
                  (emaillog.unread)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        (emaillog.tenantresponse)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _createTextVNode(" Tenant has selected "),
                              _createElementVNode("b", null, _toDisplayString(emaillog.responsedescription ?  emaillog.responsedescription :  getButtonLabel(emaillog.tenantresponse)), 1),
                              _createTextVNode(" option from email ")
                            ]))
                          : _createCommentVNode("", true),
                        (emaillog.responseemailaddress)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _createTextVNode(" The response came from "),
                              _createElementVNode("b", null, _toDisplayString(emaillog.responseemailaddress), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (emaillog.logdate)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, " Date message received: " + _toDisplayString(_unref(actProperty).formatUtcDatetimeForDisplay(emaillog.logdate)), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (booking.value.id === selectedbooking.value.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", null, [
                  (booking.value.titlenotes)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _hoisted_30,
                        _createElementVNode("span", null, [
                          _createElementVNode("span", _hoisted_31, _toDisplayString(booking.value.titlenotes), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (booking.value?.leadbooking)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        (
                      booking.value?.leadbooking?.startdate ||
                      booking.value.leadbooking?.enddate
                    )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                              _hoisted_34,
                              _createElementVNode("span", _hoisted_35, _toDisplayString(booking.value?.leadbooking.bookingdate), 1),
                              _createElementVNode("span", _hoisted_36, _toDisplayString(booking.value?.leadbooking.starttime), 1),
                              _createElementVNode("span", _hoisted_37, _toDisplayString(booking.value?.leadbooking.endtime), 1),
                              _createElementVNode("span", _hoisted_38, "(" + _toDisplayString(masterReportType.value) + ") ", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_appointmenttime.value != 'Invalid date')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _hoisted_40,
                        _createElementVNode("span", _hoisted_41, _toDisplayString(_appointmenttime.value), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (booking.value.inspector && booking.value.inspector.name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _hoisted_43,
                        _createTextVNode(" " + _toDisplayString(booking.value.inspector.name), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (subbookingdatetimeflag.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prepandKeyJobData.value, (prepdata, $prepdata) => {
                          return (_openBlock(), _createElementBlock("div", { key: $prepdata }, [
                            (prepdata.inspector.name)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                  _hoisted_46,
                                  _createElementVNode("span", null, _toDisplayString(prepdata.inspector.name), 1),
                                  _createElementVNode("span", _hoisted_47, " (" + _toDisplayString(prepdata.subtype) + ") ", 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (booking.value?.leadbooking)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        (
                      booking.value?.leadbooking?.inspector ||
                      booking.value.leadbooking?.inspector.name
                    )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                              _hoisted_50,
                              _createElementVNode("span", null, _toDisplayString(booking.value.leadbooking?.inspector.name), 1),
                              _createElementVNode("span", _hoisted_51, " (" + _toDisplayString(masterReportType.value) + ") ", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (
                    booking.value.customer &&
                    (booking.value.customer.companyName ||
                      booking.value.keypickupbranchname ||
                      booking.value.customer.branchName)
                  )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(booking.value.customer.companyName) + " - " + _toDisplayString(booking.value.keypickupbranchname
                      ? booking.value.keypickupbranchname
                      : booking.value.customer.branchName), 1))
                    : _createCommentVNode("", true),
                  (
                    booking.value.bookedbyname ||
                    booking.value.bookedbymobile ||
                    booking.value.bookedbyemail
                  )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(booking.value.bookedby, (bookedby, $bbindex) => {
                          return (_openBlock(), _createElementBlock("div", { key: $bbindex }, [
                            _hoisted_54,
                            _createElementVNode("span", _hoisted_55, _toDisplayString(bookedby.bbname), 1),
                            _createElementVNode("span", _hoisted_56, _toDisplayString(bookedby.bbemail), 1),
                            _createElementVNode("span", _hoisted_57, _toDisplayString(bookedby.bbmobile), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (booking.value.tenants.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(booking.value.tenants, (tenant, $bbindex) => {
                          return (_openBlock(), _createElementBlock("div", { key: $bbindex }, [
                            (tenant.ttname)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_59, [
                                  _hoisted_60,
                                  _createTextVNode(_toDisplayString(tenant.ttname), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (tenant.ttemail)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_61, [
                                  _hoisted_62,
                                  _createTextVNode(" " + _toDisplayString(tenant.ttemail), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (tenant.ttmobile)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_63, [
                                  _hoisted_64,
                                  _createTextVNode(_toDisplayString(tenant.ttmobile), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (booking.value.internaljobtype != 'Check-In - back to back')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                        (booking.value.keypickup)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_66, [
                              _hoisted_67,
                              _createTextVNode(_toDisplayString(booking.value.keypickup), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (
                      booking.value.keypickup === 'From Agency' &&
                      booking.value.keypickupbranchname
                    )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_68, [
                              _hoisted_69,
                              _createTextVNode(" " + _toDisplayString(booking.value.keypickupbranchname), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (
                      (booking.value.keypickup === 'From Agency' ||
                        booking.value.keypickup === 'Via Concierge' ||
                        booking.value.keypickup === 'Via Landlord') &&
                      booking.value.keypickupfromaddress.phone
                    )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_70, [
                              _hoisted_71,
                              _createTextVNode(" " + _toDisplayString(booking.value.keypickupfromaddress.phone), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (
                    booking.value.connectedbooking &&
                    booking.value.connectedbooking.internaljobtype !=
                      'Check-In - back to back'
                  )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                        (booking.value.releasekeysto)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_73, [
                              _hoisted_74,
                              _createTextVNode(_toDisplayString(booking.value.releasekeysto), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (booking.value.releasekeystobranchname)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_75, [
                              _hoisted_76,
                              _createTextVNode(_toDisplayString(booking.value.releasekeystobranchname), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (primaryErrors.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                        _hoisted_78,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(primaryErrors.value, (errors, $primaryerror) => {
                          return (_openBlock(), _createElementBlock("div", { key: $primaryerror }, [
                            _createElementVNode("span", null, _toDisplayString(errors.message), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (secondaryErrors.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                        _hoisted_80,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(secondaryErrors.value, (errors, $secondaryerror) => {
                          return (_openBlock(), _createElementBlock("div", { key: $secondaryerror }, [
                            _createElementVNode("span", null, _toDisplayString(getPresetErrorMessage(errors)), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_81, [
                (booking.value.checkoutWithoutDataentry)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: "fas fa-2x fa-skull-crossbones icon-botton-right",
                      style: {"color":"yellow"},
                      title: skulltitle.value
                    }, null, 8, _hoisted_82))
                  : _createCommentVNode("", true),
                (booking.value.provisional)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 1,
                      class: "fa fa-3x fa-exclamation-circle icon-botton-right",
                      style: {"color":"yellow"},
                      title: `Provisional booking: ${booking.value.provisionalnotes}`
                    }, null, 8, _hoisted_83))
                  : _createCommentVNode("", true),
                (
                  !booking.value.issued &&
                  !booking.value.provisional &&
                  booking.value.tenantattending != 'unsure' &&
                  booking.value.confirmaccess
                )
                  ? (_openBlock(), _createElementBlock("i", _hoisted_84))
                  : _createCommentVNode("", true),
                (booking.value.locked)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 3,
                      class: "fas fa-lock icon-botton-right",
                      style: {"color":"yellow"},
                      title: booking.value.lockedby
                    }, null, 8, _hoisted_85))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ], 14, _hoisted_1))
}
}

})